<!-- 需要自定义骨架展示时机时使用 -->
<script lang="ts">
  export let height: string;
  export let mheight = '';
  export let background: string = '';
  export let loaded: boolean;
</script>

<style lang="scss">
  .skeleton-wrap {
    min-height: var(--height);
    background: var(--background);
  }
  @media screen and (max-width: 640px) {
    .skeleton-wrap {
      min-height: var(--mheight);
    }
  }
</style>

<div class="skeleton-wrap" style="--height: {height};--mheight: {mheight || height};--background: {background};">
  {#if loaded}
    <slot />
  {:else}
    <slot name="skeleton" />
  {/if}
</div>
